import clsx from 'clsx'
import {toAbsoluteUrl} from '../../../helpers'
import {HeaderUserMenu} from '../../../partials'
import {useLayout} from '../../core'

const itemClass = 'ms-1 ms-md-4'
const userAvatarClass = 'symbol-35px'

const Navbar = () => {
  const {config} = useLayout()

  return (
    <div className='app-navbar flex-shrink-0'>
      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <img 
            src={toAbsoluteUrl('/media/logos/favicon.png')} 
            alt='Logo' 
            style={{
              width: 'auto',
              height: '35px',
              aspectRatio: '1 / 1',
              objectFit: 'contain'
            }}
          />
        </div>
        <HeaderUserMenu />
      </div>

    </div>
  )
}

export {Navbar}